module.exports = __webpack_public_path__ + "static/media/create.237bbed5.svg";